export default __webpack_public_path__ + "static/media/man-1.c77266a1.jpg";